import route from '../../constants/routes';
import { getRoutePartWithSlug } from '../../utils/common';

export const getFestivalRoute = (festival, year) =>
  `${route.FESTIVALS}/${year || festival?.year}/${festival?.country?.slug}/${getRoutePartWithSlug(festival)}`;
